module.exports = __webpack_public_path__ + "img/b8e4b2c.png";